export default __webpack_public_path__ + "static/11-fit-a96f146ef6ac31f9db3ebf5973c435b9.png";